import axios, { AxiosError } from 'axios';

axios.defaults.baseURL = `${process.env.REACT_APP_API}`;
axios.defaults.withCredentials = true;

let csrfToken: string = '';

axios.interceptors.request.use((req) => {
  // set headers on each request
  // set token
  const token = sessionStorage.getItem('token');
  if (token) req.headers.Authorization = `Token ${token}`;

  // set language
  const language = localStorage.getItem('i18nextLng');
  if (language) req.headers['Accept-Language'] = language;

  if (csrfToken !== '') {
    req.headers['X-CSRFToken'] = csrfToken;
  }

  return req;
});

export const throwAxiosError = (error: any) => {
  const err: AxiosError = error as AxiosError;
  throw new Error(err?.response?.data);
};

export async function getCsrfToken() {
  if (csrfToken === '') {
    const response = await fetch(`${axios.defaults.baseURL}/csrf/`, {
      credentials: 'include',
    });
    const data = await response.json();
    csrfToken = data.csrfToken;
  }
  return csrfToken;
}

export async function refreshCsrfToken() {
  csrfToken = '';
  await getCsrfToken();
}
export default axios;
